import React from 'react';
import {StyleSheet, View, Dimensions} from 'react-native';
import Styles from '../../Styles';
import AVText from 'src/components/elements/AVText';
import {CampusLocationType} from 'src/types/CampusLocationTypes';
import Localized from 'src/constants/AppStrings';
import {MachineType} from 'src/types/MachineType';
import {getDescriber} from './descriptor/DescriptorType';

type VendingLocationViewProps = {
  location: CampusLocationType;
  onLocationClick: (machine, autoAdvanced?: boolean) => Promise<void>;
  onPlanogramClick?: (machine: MachineType) => void;
  isOnlyTile: boolean;
};

const width = Dimensions.get('window').width;

const NewVendingLocationView = (props: VendingLocationViewProps) => {
  const {getVendingTile, getTileButton} = getDescriber();

  return (
    <View
      accessible={true}
      accessibilityRole="button"
      accessibilityLabel={`Location${
        props.location.displayName ?? props.location.name
      }`}
      aria-label={`Location${
        props.location.displayName ?? props.location.name
      }`}
      accessibilityHint={`Double tap to select ${
        props.location.displayName ?? props.location.name
      }`}
      style={[
        styles.container,
        !props.isOnlyTile && {width: styles.container.width / 2},
      ]}
    >
      <View style={styles.textView}>
        <AVText
          accessibilityLabel={`LocationName${
            props.location.displayName ?? props.location.name
          }`}
          accessibilityRole="text"
          aria-label={`${
            props.location.displayName ?? props.location.name
          }, text`}
          numberOfLines={1}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
          style={getVendingTile().nameText}
        >
          {props.location.displayName ?? props.location.name}
        </AVText>
        {props.isOnlyTile ? (
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            {getTileButton(
              Localized.Buttons.view_nutritional_info,
              () => props.onPlanogramClick(props.location),
              true,
            )}
            {getTileButton(
              Localized.Buttons.continue,
              () => props.onLocationClick(props.location),
              false,
            )}
          </View>
        ) : (
          <>
            {getTileButton(
              Localized.Buttons.view_nutritional_info,
              () => props.onPlanogramClick(props.location),
              true,
            )}
            {getTileButton(
              Localized.Buttons.continue,
              () => props.onLocationClick(props.location),
              false,
            )}
          </>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: width - Styles.Spacing.m3 * 2,
    marginHorizontal: Styles.Spacing.m3,
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    borderRadius: Styles.Spacing.m2,
    ...Styles.Style.shadow,
  },
  textView: {
    flex: 1,
    justifyContent: 'center',
    paddingVertical: Styles.Spacing.m3,
    marginHorizontal: Styles.Spacing.m2 + Styles.Spacing.m1,
  },
});

export default NewVendingLocationView;
